export const createChat = async (
  name,
  fetchInstance,
) => {
  const createdChat = (
    await fetchInstance.post('/chat', JSON.stringify({ name }), {
      'Content-Type': 'application/json',
    })
  ).json();

  return createdChat;
};

export const getChats = async (
  fetchInstance,
) => {
  const response = await fetchInstance.get('/chat');

  return (await response.json()).chats;
};

export const addQuestion = async (
  { chatId, chatQuestion },
  fetchInstance,
) => {
  const response = await fetchInstance.post(
    `/chat/${chatId}/question`,
    JSON.stringify(chatQuestion),
    {
      'Content-Type': 'application/json',
    },
  );

  return response.json();
};

export const getHistory = async (
  chatId,
  fetchInstance,
) => (await fetchInstance.get(`/chat/${chatId}/history`)).json();

export const updateChat = async (
  chatId,
  chat,
  fetchInstance,
) => (await fetchInstance.put(`/chat/${chatId}/metadata`, JSON.stringify(chat), {
  'Content-Type': 'application/json',
})).json();
